import { useState } from "react";
import { LayoutDashboard, UserRound, Gift, Plane, Settings2 } from "lucide-react";
import { CommissionsOverview } from "./admin-commissions/CommissionsOverview";
import { PartnerFiche } from "./admin-commissions/PartnerFiche";
import { CommissionSettings } from "./admin-commissions/CommissionSettings";
import { AdvantageCatalog } from "./admin-commissions/AdvantageCatalog";
import { TravelEditions } from "./admin-commissions/TravelEditions";

const SUB_TABS = [
  ["overview", "Vue d'ensemble", LayoutDashboard],
  ["partner", "Fiche partenaire", UserRound],
  ["catalog", "Catalogue avantages", Gift],
  ["travel", "Voyage CozyHome", Plane],
  ["settings", "Réglages", Settings2],
];

export const AdminCommissions = () => {
  const [sub, setSub] = useState("overview");
  return (
    <div data-testid="admin-commissions">
      <div className="flex flex-wrap gap-2">
        {SUB_TABS.map(([id, label, Icon]) => (
          <button
            key={id}
            data-testid={`commissions-subtab-${id}`}
            onClick={() => setSub(id)}
            className={`flex items-center gap-1.5 rounded-full border px-4 py-1.5 text-xs font-bold transition-colors ${
              sub === id ? "border-navy bg-navy text-white" : "border-slate-200 text-slate-500 hover:border-navy"
            }`}
          >
            <Icon className="h-3.5 w-3.5" /> {label}
          </button>
        ))}
      </div>
      <div className="mt-5">
        {sub === "overview" && <CommissionsOverview />}
        {sub === "partner" && <PartnerFiche />}
        {sub === "catalog" && <AdvantageCatalog />}
        {sub === "travel" && <TravelEditions />}
        {sub === "settings" && <CommissionSettings />}
      </div>
    </div>
  );
};
